<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="600px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col
            :span="5"
            style="padding-right: 20px;float: right;text-align:right;"
          >
            <el-button
              type="primary"
              @click="selectItemFun()"
            >
              选择区域
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          is-select-field
          :is-filter="false"
          :multiple-selection.sync="multipleSelection"
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @selectItem="selectItemFun"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'

import { listAreaApi } from '@/api/v2/area';
export default {
  name: 'AreaList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    },
    provinceId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'area_list_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'select',
            label: '选择区域',
            method: 'selectItem'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 20, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {}
        }
      },
      multipleSelection: [],
      isPaging: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.multipleSelection = []
        this.tableList.initTableColumn = [
          { prop: 'name', label: '区域名称'}
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      listAreaApi({parentId: this.provinceId, isUserArea: 0}).then(response => {
        this.tableList.tableLoading = false
        let data = response.data ? response.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.length
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 选择区域
    selectItemFun () {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择区域',
          type: 'warning'
        })
        return
      } else {
        this.$emit('selectedAreaFun', this.multipleSelection)
        this.modalClose()
      }
    }
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
